module.exports = __webpack_public_path__ + "img/a64a5a6.jpg";